import { render, staticRenderFns } from "./AnnualizationReports.vue?vue&type=template&id=0487fa7d&scoped=true"
import script from "./AnnualizationReports.vue?vue&type=script&lang=js"
export * from "./AnnualizationReports.vue?vue&type=script&lang=js"
import style0 from "./AnnualizationReports.vue?vue&type=style&index=0&id=0487fa7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0487fa7d",
  null
  
)

export default component.exports